import {
  StateProps,
  ContainerProps,
  makeMapStateToProps,
  mapDispatchToProps,
  DispatchProps,
} from "./map-to-props-factory";
import { createUniversalConnector } from "../universal-connector-factory";
import { withSportsbookBetslipContext, type SportsbookBetslipContext } from "../../context/sportsbook";
import { ComponentProps } from "./props";

export default withSportsbookBetslipContext(
  ({ localization, config, session, capabilities, preferences, balance }: SportsbookBetslipContext) => ({
    localization,
    config,
    session,
    capabilities,
    preferences,
    balance,
  }),
)(
  createUniversalConnector<StateProps, DispatchProps, ContainerProps, ComponentProps>(
    makeMapStateToProps,
    mapDispatchToProps,
  ),
);
